export enum GlLocationEnum {
  DOMESTIC = 'DOMESTIC',
  ABROAD = 'ABROAD',
  ANY = 'ANY',
}
